// Externe Bibliotheken

// Interne Module
import { PaymentType } from '@/model/common/PaymentType';

// Komponenten
import PayPal from '@/comp/payment/paymentCard/types/PayPal';
import CreditCard from '@/comp/payment/paymentCard/types/CreditCard';
import DirectDebit from '@/comp/payment/paymentCard/types/DirectDebit';
import { Icon } from '@/comp/icon/icon';

// Styles
import './paymentCard.scss';

// Assets
import masterCardSvg from '@/assets/img/payment/mastercard.svg';
import visaSvg from '@/assets/img/payment/visa.svg';
import payPalSvg from '@/assets/img/payment/paypal.svg';
import { PaymentData } from '@/model/payment/payment';

type PaymentCardProps = {
    type: PaymentType;
    showRadioButton: boolean;
    active?: boolean;
    alreadyTested?: boolean;
    setPaymentData?: (content: PaymentData) => void;
    paymentData?: unknown;
};

const nameMapping = {
    [PaymentType.PayPal]: {
        friendlyName: 'PayPal',
        className: 'paypal',
    },
    [PaymentType.CreditCard]: {
        friendlyName: 'Kreditkarte',
        className: 'credit-card',
    },
    [PaymentType.DirectDebit]: {
        friendlyName: 'Lastschrift',
        className: 'direct-debit',
    },
};

const PaymentCard = ({ type, active, showRadioButton = true, ...props }: PaymentCardProps) => {
    const getPaymentComponent = (type: PaymentType) => {
        switch (type) {
            case PaymentType.PayPal:
                return <PayPal active={active} {...props} />;
            case PaymentType.CreditCard:
                return <CreditCard active={active} {...props} />;
            case PaymentType.DirectDebit:
                return <DirectDebit active={active} {...props} />;
            default:
                return null;
        }
    };

    return (
        <article className={`payment-card ${nameMapping[type].className}${active ? ' active' : ''}`}>
            <div className={`card-content${!showRadioButton ? ' no-radio-button' : ''}`}>
                <div className="card-header">
                    {showRadioButton && <div className="radio-button"></div>}
                    <div className="logo-container">
                        {type === PaymentType.PayPal ? (
                            <img className="logo paypal" src={payPalSvg} alt="PayPal Logo" />
                        ) : type === PaymentType.CreditCard ? (
                            <>
                                <img className="logo master-card" src={masterCardSvg} alt="MasterCard Logo" />
                                <img className="logo visa" src={visaSvg} alt="Visa Logo" />
                            </>
                        ) : type === PaymentType.DirectDebit ? (
                            <>
                                <Icon name="edit" ariaHidden />
                                <Icon name="creditCard" ariaHidden />
                            </>
                        ) : null}
                    </div>
                    <div className="text-container">
                        <h4 className="card-headline">{nameMapping[type].friendlyName}</h4>
                        <div className="trust-element">
                            <Icon name="lock" ariaHidden />
                            Kostenlos und sicher
                        </div>
                    </div>
                </div>
                {getPaymentComponent(type)}
            </div>
        </article>
    );
};
export default PaymentCard;
